






































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import TabChange from './tabChange.vue'
import Empty from '@/components/Empty/index.vue'
import {
  getOrderDetailPage3,
  queryZjDetailById,
  passAudit3,
  orderPrint2,
  getOrderListBy3,
  queryLevel,
  deleteOrder,
  deleteZj,
  zjUpload,
  allPrint,
  queryResvDetail,
  healthCertUpload,
  healthCertBatchUpload

} from '@/api/order'
import { UserModule } from '../../store/modules/user'
import { exportData, exportInfor } from '@/api'
@Component({
  components: {
    HeadLable,
    InputAutoComplete,
    TabChange,
    Empty,
  },
})
export default class extends Vue {
  private defaultActivity: any = 0
  private orderStatics = {}
  private dialogOrderStatus = 0
  private row = {}
  private isAutoNext = true
  private loading = false
  private visible = false
  private isTableOperateBtn = true
  private currentPageIndex = 0 //记录查看详情数据的index
  private orderId = '' //订单号
  private phone = '' //搜索条件的手机号
  private input = '' //搜索条件的订单号
  private zjh = '' //搜索条件的证件号
  private age = '' //年龄
  private valueTime = []
  private dialogVisible = false //详情弹窗
  private cancelDialogVisible = false //取消，拒单弹窗
  private cancelDialogTitle = '' //取消，拒绝弹窗标题
  private cancelReason = ''
  private remark = '' //自定义原因
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private tableData = []
  private diaForm = []
  private id = ''
	private status = 0
	private zjResult = 0
  private isSearch: boolean = false
  private orderStatus = 0 //列表字段展示所需订单状态,用于分页请求数据
  private checkList: string[] = []
  private zjAll = ''
  private level = 1
  private outputDateStr: string
  private checkZjresult: any[]
  private currentTime: string | null = null; // 初始值可以根据实际情况设置，这里设为 null
  private showNotification: boolean
  private notificationTitle: string
  private notificationText: string
  private timer: any = null


  created() {

    this.getLevel()
    this.init(Number(this.$route.query.zjResult) || 3)
    this.zjResult = Number(this.$route.query.zjResult) || 0;
    console.log(this.orderStatus)
  }
  getLevel(){
    const username = UserModule.username

    queryLevel(username)
      .then((res)=>{
        if (res.data.code === 1) {
          this.level=res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  mounted() {
    //如果有值说明是消息通知点击进来的
    if (
      this.$route.query.orderId &&
      this.$route.query.orderId !== 'undefined'
    ) {
      this.goDetail(this.$route.query.orderId, 2)
    }
    if (this.$route.query.zjResult) {
      this.defaultActivity = this.$route.query.zjResult
    }
    // 启动自动刷新（每5分钟）
    this.timer = setInterval(() => {
      queryResvDetail().then(res => {
        if (res.data.code === 1 && res.data.data.status === 1) {
          this.showNotification = true;
          this.notificationTitle = '预约管理尚未审核';
        }
      });
    }, 300000); // 5000ms = 5秒
    // console.log(this.$route.query, 'this.$route')
  }

  // 单条上传健康证信息（后端组装数据并调用健康证平台）
  async upload(row: any) {
    if (!row || !row.id) {
      this.$message.warning('请先选择要上传的健康证记录')
      return
    }
    this.loading = true
    try {
      const res = await healthCertUpload({ orderId: row.id })
      if (res.data && res.data.code === 1) {
        this.$message.success('健康证上传成功')
        this.init(this.orderStatus)
      } else {
        this.$message.error((res.data && res.data.msg) || '上传失败')
      }
    } catch (err) {
      this.$message.error('上传请求出错了：' + err.message)
    } finally {
      this.loading = false
    }
  }

  // 批量上传健康证信息（收集勾选记录，前端只传订单id列表，由后端组装数据并调用健康证平台批量接口）
  async allUpload() {
    // 收集勾选的记录id；如果直接点了单行操作按钮传入row，也纳入
    const idsToSend: string[] = []
    if (this.checkList && this.checkList.length > 0) {
      idsToSend.push(...this.checkList)
    }
    const uniqueIds = [...new Set(idsToSend)]
    if (uniqueIds.length === 0) {
      this.$message.warning('请先勾选要批量上传的健康证记录')
      return
    }
    if (uniqueIds.length > 100) {
      this.$message.warning('单次最多上传 100 条，请分批上传')
      return
    }
    this.loading = true
    try {
      const res = await healthCertBatchUpload({ orderIds: uniqueIds })
      if (res.data && res.data.code === 1) {
        this.$message.success(
          (res.data.data && res.data.data.msg) || '批量上传已提交，请稍后刷新查看结果'
        )
        this.init(this.orderStatus)
      } else {
        this.$message.error((res.data && res.data.msg) || '批量上传失败')
      }
    } catch (err) {
      this.$message.error('批量上传请求出错了：' + err.message)
    } finally {
      this.loading = false
    }
  }

  initFun(orderStatus) {
    this.page = 1
    this.init(orderStatus)
  }

  change(activeIndex) {
    if (activeIndex === this.orderStatus) return
    this.init(activeIndex)
    this.input = ''
    this.phone = ''
    this.zjh = ''
    this.valueTime = []
    this.dialogOrderStatus = 0
    this.$router.push('/category')
    console.log(activeIndex, '接收到了子组件的index')
  }

  formatGender(row, column, cellValue) {
    if (cellValue === 1) {
      return '男';
    } else if (cellValue === 2) {
      return '女';
    }
    return cellValue;
  }


  calculateAge(row, column, cellValue) {
    const passportMap = {
      "P123456789": "1990-05-15",
      "P987654321": "1985-10-20"
    };
    if (cellValue.length == 9){
      const birthDateStr = passportMap[cellValue];
      if (!birthDateStr) {
        console.log("未找到该护照号码对应的出生日期");
        return null;
      }
      const today = new Date();
      const birth = new Date(birthDateStr);
      let age = today.getFullYear() - birth.getFullYear();
      const m = today.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      return age;
    }else {
      if (!cellValue) return '';
      const birthDate = new Date(cellValue.slice(6, 10), cellValue.slice(10, 12) - 1, cellValue.slice(12, 14));
      const now = new Date();
      let age = now.getFullYear() - birthDate.getFullYear();
      const monthDiff = now.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    }
  }
  // 获取证件状态：1.待上传 2.待颁发 3.已颁发数量
  getOrderListBy3Status() {
    getOrderListBy3({})
      .then((res) => {
        if (res.data.code === 1) {
          this.orderStatics = res.data.data
          console.log(this.orderStatics, '获取到的证件状态')
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  init(activeIndex: number = 0, isSearch?) {
    this.isSearch = isSearch
    // 如果status发生变化，则重置page为1，否则保持原值
    const page = (this.orderStatus !== activeIndex) ? 1 : this.page;
    const params = {
      page: page,
      pageSize: this.pageSize,
      username: this.input || undefined,
      age: this.age || undefined,
      phoneNum: this.phone || undefined,
      certificateNumber: this.zjh || undefined,
      beginTime:
        this.valueTime && this.valueTime.length > 0
          ? this.valueTime[0]
          : undefined,
      endTime:
        this.valueTime && this.valueTime.length > 0
          ? this.valueTime[1]
          : undefined,
      zjResult: activeIndex || undefined,
    }
    getOrderDetailPage3({ ...params })
      .then((res) => {
        if (res.data.code === 1) {
          this.tableData = res.data.data.records
          this.orderStatus = activeIndex
          this.counts = Number(res.data.data.total)
          this.getOrderListBy3Status()
          if (
            this.dialogOrderStatus === 2 &&
            this.orderStatus === 2 &&
            this.isAutoNext &&
            !this.isTableOperateBtn &&
            res.data.data.records.length > 1
          ) {
            const row = res.data.data.records[0]
            this.goDetail(row.id, row.zjResult, row)
          } else {
            return null
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }
//预约状态
  getOrderType(row: any) {
    if (row.zjResult === 1) {
      return '待颁发'
    } else if (row.zjResult === 2) {
      return '已上传'
    } else if (row.zjResult === 3) {
      return '已颁发 待上传'
    }else if (row.zjResult === 4) {
      return '已上传'
    }
  }

  get isWaitUpload() {
    return this.orderStatus === 1;
  }
  get isWaitAudit() {
    return this.orderStatus === 3;
  }
  get isAlreadyAudit() {
    return this.orderStatus === 4;
  }

  get isAlreadyUpload() {
    return this.orderStatus === 2;
  }
  // 查看详情
  async goDetail(id: any, zjResult: number, row?: any) {
    this.diaForm = []
    this.dialogVisible = true
    this.dialogOrderStatus = zjResult
    this.orderId = id
    console.log("id是"+id)
    const { data } = await queryZjDetailById({ orderId: id })
    this.diaForm = data.data

    // 将字符串转换为 Date 对象
const inputDate = new Date((this.diaForm as any).validEndDate);

  // 检查日期是否有效
  if (isNaN(inputDate.getTime())) {
      console.error('Invalid date');
  } else {
      // 设置日期为一年后的日期
      // inputDate.setFullYear(inputDate.getFullYear() + 1);

      // 格式化日期为 YYYY-MM-DD
      const year = inputDate.getFullYear();
      const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要+1
      const day = String(inputDate.getDate()).padStart(2, '0');

      this.outputDateStr = `${year}-${month}-${day}`;
  }

    this.row = row || { id: this.$route.query.orderId, zjResult: zjResult }
    if (this.$route.query.orderId) {
      this.$router.push('/category')
    }
  }

  exportUploadData() {
    this.$confirm('是否确认导出待上传数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => { // 用户点击了确定按钮
      exportData()
        .then((response) => {
          const { data } = response;
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })); // 确保data是Blob类型，并设置正确的MIME类型
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = `待上传数据.xls`;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('导出失败:', error); // 处理导出失败的情况
        });
    }).catch(() => { // 用户点击了取消按钮
      // 这里可以处理取消操作，但通常不需要做什么，因为用户已经取消了导出
    });
  }

  async showWord(row: any) {
    this.loading = true;
    const orderId = row.id;
    console.log("打印体检单是"+this.orderId)
    // 调用orderPrint函数并处理返回的Promise
      try {
        const data = await orderPrint2(orderId); // 直接等待orderPrint的结果
        // 假设res是包含PDF文档流数据的ArrayBuffer或其他可转换为Blob的格式
        const blob = new Blob([data], { type: 'application/pdf' });

        // 创建一个iframe用于打印
        const iframe = document.createElement('iframe');
        (iframe.style as any).frameborder = '0'; // 注意这里应该是'0'而不是'no'
        iframe.style.display = 'none';
        iframe.setAttribute('id', 'printPdf');
        iframe.setAttribute('name', 'printPdf');

        // 将Blob的URL设置为iframe的源
        iframe.src = window.URL.createObjectURL(blob);

        // 将iframe添加到文档中
        document.body.appendChild(iframe);
        // 监听iframe加载完成
        iframe.onload = () => {
            try {
                const ordonnance = iframe.contentWindow;
                if (ordonnance && ordonnance.document) {
                    ordonnance.document.execCommand('print', false, null);
                }
                // 清理：如果不需要显示PDF，这里不需要更改display属性
                // document.body.removeChild(iframe);
                // window.URL.revokeObjectURL(iframe.src);
            } catch (error) {
                console.error('Failed to print PDF:', error);
                // 显示错误或进行其他处理
            }
        };

        // document.body.appendChild(iframe);

/*        // 可选：添加一个按钮来控制iframe的显示
        const showPdfButton = document.createElement('button');
        showPdfButton.textContent = '显示PDF';
        showPdfButton.onclick = () => {
            iframe.style.display = iframe.style.display === 'none' ? 'block' : 'none';
        };
        document.body.appendChild(showPdfButton);*/
        this.loading = false;
    } catch (error) {
        this.loading = false;
        console.error('请求失败:', error);
    }  }
  // 跳转添加预约信息
  private MessageHandle(st : string, username : string) {
			if (st === 'add') {
				this.$router.push({ path: '/orderDetails/add' })
			} else {
				if (username === 'admin') {
					return
				}
				this.$router.push({ path: '/category/update', query: { id: st } })
			}
		}


//上传证件
  async passAudit(row: any) {
    let zjResult;
    // 构建要发送的 ID 列表，根据 row 和 checkList
    const idsToSend: string[] = [];
    if (row && typeof row === 'object' && row.hasOwnProperty('id')) {
      idsToSend.push(row.id);
    }
    idsToSend.push(...this.checkList); // 将 checkList 中的所有 ID 添加到列表中

    // 去除重复的 ID（可选）
    const uniqueIds = [...new Set(idsToSend)];

    // 逐个发送请求
    for (const id of uniqueIds) {
      try {
        this.diaForm = []

        const { data } = await queryZjDetailById({ orderId: id })
        this.diaForm = data.data
        zjResult = this.diaForm.zjResult

        if (zjResult === 1){
          zjResult = 2;
        }else if (zjResult === 3) {
          zjResult = 4;
        }
        const params = { zjResult, id };
        console.log(params)
        console.log(`Sending request for ID: ${id}`);
        const response = await zjUpload(params); // 假设 passAudit3 返回一个 Promise
        if (response.data && response.data.code === 1) {
          console.log(`Success for ID: ${id}`);
          // 可以在这里添加成功后的逻辑，比如更新 UI
          } else {
          console.error(`Failed for ID: ${id}, Message: ${response.data.msg}`);
          // 可以在这里添加失败后的逻辑，比如显示错误消息
          // 注意：如果某个 ID 发送失败，这里的逻辑不会停止循环，会继续发送下一个 ID
        }
      } catch (error) {
        console.error(`Request failed for ID: ${id}, Error: ${error.message}`);
        // 处理请求错误，比如显示错误消息或记录日志
        // 注意：这里的错误处理不会停止循环，会继续发送下一个 ID
          }
    }

    // 所有请求发送完毕后，可以在这里添加最终逻辑，比如显示完成消息
    console.log('All requests sent.');
    if (zjResult == 2 || zjResult ==4){
      this.$message.error('上传失败！该证件已颁发上传');
    }else {
      this.$message.success('上传状态已经更改成功！'); // 假设这是您的 UI 框架的消息方法
    }

    this.init(this.orderStatus)

    // 如果需要，可以调用 this.init() 或其他方法来刷新 UI
		}
async noPassAudit(row) {
  const currentTime = new Date().toLocaleString(); // 获取当前时间
  let zjResult;


  // 构建要发送的 ID 列表，根据 row 和 checkList
  const idsToSend: string[] = [];
  if (row && typeof row === 'object' && row.hasOwnProperty('id')) {
    idsToSend.push(row.id);
  }
  idsToSend.push(...this.checkList); // 将 checkList 中的所有 ID 添加到列表中

  // 去除重复的 ID（可选）
  const uniqueIds = [...new Set(idsToSend)];

  // 逐个发送请求
  for (const id of uniqueIds) {
    try {
      this.diaForm = []
      console.log(this.diaForm)
      const { data } = await queryZjDetailById({ orderId: id })
      this.diaForm = data.data
      zjResult = this.diaForm.zjResult

      if (zjResult == 3 || zjResult ==4){
        this.$message.error('颁发失败！该证件已颁发');
        return;
      }

      if (zjResult === 1){
        zjResult = 3;
      }else if (zjResult === 2) {
        zjResult = 4;
      }
      const params = { zjResult, id };
      console.log(`Sending request for ID: ${id}`);

      const response = await passAudit3(params); // 假设 passAudit3 返回一个 Promise
      if (response.data && response.data.code === 1) {
        console.log(`Success for ID: ${id}`);
        // 可以在这里添加成功后的逻辑，比如更新 UI
      } else {
        console.error(`Failed for ID: ${id}, Message: ${response.data.msg}`);
        // 可以在这里添加失败后的逻辑，比如显示错误消息
        // 注意：如果某个 ID 发送失败，这里的逻辑不会停止循环，会继续发送下一个 ID
      }
    } catch (error) {
      console.error(`Request failed for ID: ${id}, Error: ${error.message}`);
      // 处理请求错误，比如显示错误消息或记录日志
      // 注意：这里的错误处理不会停止循环，会继续发送下一个 ID
          }
  }

    // 所有请求发送完毕后，可以在这里添加最终逻辑，比如显示完成消息
    console.log('All requests sent.');
    if (zjResult == 3 || zjResult ==4){
    this.$message.success('证件状态已经更改成功！'); // 假设这是您的 UI 框架的消息方法
    }

    this.init(this.orderStatus)

  // 如果需要，可以调用 this.init() 或其他方法来刷新 UI
  }

  async allPrint(row) {
    const idsToSend: string[] = [];
    if (row && typeof row === 'object' && 'id' in row) {
      idsToSend.push(row.id);
    }
    idsToSend.push(...this.checkList);
    const uniqueIds = [...new Set(idsToSend)];

    try {
      const response = await allPrint(uniqueIds);

      // 创建下载链接
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '证件合并.pdf');
      document.body.appendChild(link);
      link.click();

      // 清理
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      this.$message.success("下载成功");
    } catch (error) {
      this.$message.error("下载失败");
      console.error(error);
    }
  }

  async auditAndPrint(row){
    const currentTime = new Date().toLocaleString(); // 获取当前时间
    let zjResult;


    // 构建要发送的 ID 列表，根据 row 和 checkList
    const idsToSend: string[] = [];
    if (row && typeof row === 'object' && row.hasOwnProperty('id')) {
      idsToSend.push(row.id);
    }
    idsToSend.push(...this.checkList); // 将 checkList 中的所有 ID 添加到列表中

    // 去除重复的 ID（可选）
    const uniqueIds = [...new Set(idsToSend)];

    // 逐个发送请求
    for (const id of uniqueIds) {
      try {
        this.diaForm = []
        console.log(this.diaForm)
        const { data } = await queryZjDetailById({ orderId: id })
        this.diaForm = data.data
        zjResult = this.diaForm.zjResult

        if (zjResult == 3 || zjResult ==4){
          this.$message.error('颁发失败！该证件已颁发');
          return;
        }

        if (zjResult === 1){
          zjResult = 3;
        }else if (zjResult === 2) {
          zjResult = 4;
        }
        const params = { zjResult, id };
        console.log(`Sending request for ID: ${id}`);

        const response = await passAudit3(params); // 假设 passAudit3 返回一个 Promise
        if (response.data && response.data.code === 1) {
          console.log(`Success for ID: ${id}`);
          // 可以在这里添加成功后的逻辑，比如更新 UI
        } else {
          console.error(`Failed for ID: ${id}, Message: ${response.data.msg}`);
          // 可以在这里添加失败后的逻辑，比如显示错误消息
          // 注意：如果某个 ID 发送失败，这里的逻辑不会停止循环，会继续发送下一个 ID
        }
      } catch (error) {
        console.error(`Request failed for ID: ${id}, Error: ${error.message}`);
        // 处理请求错误，比如显示错误消息或记录日志
        // 注意：这里的错误处理不会停止循环，会继续发送下一个 ID
      }
    }

    // 所有请求发送完毕后，可以在这里添加最终逻辑，比如显示完成消息
    console.log('All requests sent.');
    if (zjResult == 3 || zjResult ==4){
      this.$message.success('证件状态已经更改成功！'); // 假设这是您的 UI 框架的消息方法
    }

    this.init(this.orderStatus)

    //打印部分
    // const idsToSend: string[] = [];
    // if (row && typeof row === 'object' && 'id' in row) {
    //   idsToSend.push(row.id);
    // }
    // idsToSend.push(...this.checkList);
    // const uniqueIds = [...new Set(idsToSend)];
    try {
      const response = await allPrint(uniqueIds);

      // 创建下载链接
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '证件合并.pdf');
      document.body.appendChild(link);
      link.click();

      // 清理
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      this.$message.success("下载成功");
    } catch (error) {
      this.$message.error("下载失败");
      console.error(error);
    }
  }

  handleClose() {
    this.dialogVisible = false
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init(this.orderStatus)
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init(this.orderStatus)
  }

  private handleSelectionChange(val: any) {
    let checkArr: any[] = []
    let checkArr2: any[] = []

    val.forEach((n: any) => {
      checkArr.push(n.id)
      checkArr2.push(n.zjResult)
    })
    this.checkList = checkArr
    this.checkZjresult = checkArr2
  }

  getpeResult(type: number): string {
  switch (type) {
    case 1: return '待体检';
    case 2: return '体检未通过';
    case 3: return '体检通过';
    case 4: return '体检通过';
    default: return '未知错误'; // 如果没有匹配到任何已知类型，则返回这个
  }
}

  private DeleteHandleZj(type : string, id : string) {
    this.visible = true;
    const confirmResult = confirm('确定要删除吗？');
    if (confirmResult) {
    deleteZj(id).then(res => {
      if(res.data.code === 1) {
        this.$message.success("删除成功")
        this.init(Number(this.$route.query.status) || 0)
      } else {
        this.$message.error(res.data.msg)
      }
    })
    } else {
      // 用户点击了取消
      console.log('用户取消删除');
    }

  }

}
